module.exports = __webpack_public_path__ + "static/ai-5-b3508dd004a987bb7c7d06f7a75a652f.png";